import { render, staticRenderFns } from "./HeaderLang.vue?vue&type=template&id=49f55030"
import script from "./HeaderLang.vue?vue&type=script&lang=js"
export * from "./HeaderLang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports